import { render } from "./RolesBadges.vue?vue&type=template&id=1ac72d5a&scoped=true"
import script from "./RolesBadges.vue?vue&type=script&lang=js"
export * from "./RolesBadges.vue?vue&type=script&lang=js"

import "./RolesBadges.vue?vue&type=style&index=0&id=1ac72d5a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac72d5a"]])

export default __exports__